// Fix this file, do not use any as the type
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/no-explicit-any */
import axios from 'axios'

import axiosInstanceApiGateway from 'config/apiServiceApiGateway'
import { getAvailableStaff } from 'features/Order/services/staffAvailability'

const { REACT_APP_BASE_URL_API } = process.env
const baseUrl = REACT_APP_BASE_URL_API
const { Get, Post, Put } = axiosInstanceApiGateway

export const geAllOrderList = (query = ''): any => axios.get(`${baseUrl}/api/order${query}`)

export const getAllOrderDetail = (id: any): any => axios.get(`${baseUrl}/api/order/${id}`)

export const getHub = (): any => axios.get(`${baseUrl}/api/locations/hub`)

export const getAllLocation = (): any => axios.get(`${baseUrl}/api/locations/order`)

export const getSuperIntersectHub = (locationId: any): any =>
  axios.get(`${baseUrl}/api/location/intersect-hub/${locationId}`)

export const getAllLocationType = (): any => axios.get(`${baseUrl}/api/location/type`)

export const putCancelOrder_AllOrder = (id: any, data: any): any =>
  axios.put(`${baseUrl}/api/order/${id}/cancel`, data)

export const putCompleteOrder_AllOrder = (id: any, data: any): any =>
  axios.put(`${baseUrl}/api/order/${id}/completion`, data)

export const postCreateOrder_AllOrder = (data: any): any =>
  axios.post(`${baseUrl}/api/order/reference`, data)

export const postVerifyLocation_AllOrder = (id: any, data: any): any =>
  axios.post(`${baseUrl}/api/driver-admin/buyer-location-validation/${id}`, data)

export const getOrderReferenceByInvoice_AllOrder = (invoice: any): any =>
  axios.get(`${baseUrl}/api/order/reference${invoice}`)

export const getAllProductInventory_AllOrder = (location_id: any, query: any): any =>
  axios.get(`${baseUrl}/api/inventory/product/${location_id}/all${query}`)

export const getDriver_OrderPooling = (location_id: any): any => getAvailableStaff(location_id)

export const postOrderPooling_OrderPooling = (data: any): any =>
  axios.put(`${baseUrl}/api/order/pooling/assign-driver`, data)

export const getCustomerAddress_AllOrder = (customerID: any, addressID: any): any =>
  Get({ url: `/accounts/internal/v1/customer-address/${customerID}/${addressID}` })

export const putCustomerAddress_AllOrder = (customerID: any, addressID: any, data: any): any =>
  Put({ url: `/accounts/internal/v1/customer-address/${customerID}/${addressID}`, data })

export const getCustomerAddressNotes_AllOrder = (): any =>
  axios.get(`${baseUrl}/api/customers/address/note`)

export const putSkipVerificationPackage = (payload: any, id: any): any =>
  axios.put(`${baseUrl}/api/packer/order/${id}/package-confirmation`, payload)
export const putSkipVerificationDropOff = (payload: any, id: any): any =>
  axios.post(`${baseUrl}/api/order/${id}/bypass`, payload)

export const geAllSuperOrderList = (query = ''): any =>
  axios.get(`${baseUrl}/api/super/order${query}`)
export const getAvailableTimeslots = (query = ''): any =>
  axios.get(`${baseUrl}/api/order/timeslots${query}`)
export const getCancelCompleteReason = (): any =>
  axios.get(`${baseUrl}/api/order/cancel-complete-reason`)

export const putSudoCancelOrder_AllOrder = (id: any, payload: any): any =>
  axios.put(`${baseUrl}/api/order/${id}/super-cancel`, payload)

export const getOrderTypes = (): any => axios.get(`${baseUrl}/api/order/types`)

export const getActionsReasons = (action: any): any =>
  Get({ url: `/oms/internal/v1/action-reasons?action=${action}` })

export const postVerifyReturn = (orderId: any, payload: any): any =>
  Post({ url: `/logistic/internal/v1/cs/deliveries/${orderId}/hold`, data: payload })
export const postOnHold = (orderId: any, payload: any): any =>
  Post({ url: `/logistic/internal/v1/cs/deliveries/${orderId}/hold`, data: payload })
export const postRedelivery = (orderId: any, payload: any): any =>
  Post({ url: `/logistic/internal/v1/cs/deliveries/${orderId}/redeliver`, data: payload })
